module.exports = __webpack_public_path__ + "media/flags/gr-5480c7c9.svg";